const IMPORT_ACTION_TYPE = {
  INITIALIZE_SERVICES: 'INITIALIZE_SERVICES',
  ENROL_YEAR_4_TEACHERS: 'ENROL_YEAR_4_TEACHERS',
  ENROL_DIRECTORS: 'ENROL_DIRECTORS',
  ENROL_FAMILIES_CROSS: 'ENROL_FAMILIES_CROSS',
  ENROL_FAMILIES_OBSERV: 'ENROL_FAMILIES_OBSERV'
}
export default IMPORT_ACTION_TYPE
